import BaseModel from '../core/BaseModel'
export default class StatusModel extends BaseModel {
    constructor() {
        super({ 
                name: "status",
                tableName: 'status', 
                label: "Trạng thái", 
                display_key: 'name', 
            },  
            {
            id: { 
                name: 'id', 
                type: "Bigint", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            code : { 
                name: 'code', 
                type: "String", 
                label: 'code', 
                sortable: false,
                filter: false,
                width : 30,
            },
            name : { 
                name: 'name', 
                type: "String", 
                label: 'Tên trạng thái', 
                sortable: false,
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
                width : 30,
            },
            type : { 
                name: 'type', 
                type: "String", 
                label: 'Loại', 
                sortable: false,
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
                width : 30,
            },
            
        },)
    }

}